export function loadCardOrder(storageKey, defaultIds) {
  try {
    const raw = localStorage.getItem(storageKey);
    if (!raw) return [...defaultIds];
    const parsed = JSON.parse(raw);
    if (!Array.isArray(parsed)) return [...defaultIds];
    return mergeCardOrder(parsed, defaultIds);
  } catch {
    return [...defaultIds];
  }
}

export function saveCardOrder(storageKey, order) {
  try {
    localStorage.setItem(storageKey, JSON.stringify(order));
  } catch {
    /* ignore quota / private mode */
  }
}

export function mergeCardOrder(savedOrder, defaultIds) {
  const valid = savedOrder.filter((id) => defaultIds.includes(id));
  defaultIds.forEach((id) => {
    if (!valid.includes(id)) valid.push(id);
  });
  return valid;
}

export function reorderIds(order, fromId, toId) {
  if (fromId === toId) return order;
  const next = order.filter((id) => id !== fromId);
  const targetIndex = next.indexOf(toId);
  if (targetIndex === -1) return order;
  next.splice(targetIndex, 0, fromId);
  return next;
}
